import { FlexLayout } from "../../layouts";
import { SubNavMolecule } from "../../molecules";
import { OverheidHeaderOrganism, ToastOrganism, VerwerkingsoverzichtOrganism } from "../../organisms";

export default function VerwerkingsoverzichtScreen() {
  return (
    <FlexLayout
      header={
        <>
          <OverheidHeaderOrganism subNav={<SubNavMolecule />} />
          <ToastOrganism />
        </>
      }
      body={<VerwerkingsoverzichtOrganism />}
    />
  );
}
